import PriceGuarantee from "../assets/bestprice.svg";
import EasyBooking  from "../assets/easybook.svg" ;
import ZeroService  from "../assets/zero.svg";
import Cruise from "../assets/cruise.svg";
import Counsellor from "../assets/cusromersupport.svg";
import HumanTouch from "../assets/humantouch.svg";
 
const Easecruisedata = [
    {
        icon:HumanTouch ,
        heading:"Technology with a Human Touch",
        content:"We are a Cruise First Online Travel Agency, but value the importance of a human connect. So feel free to look online and chat with us offline."

    }, {
        icon:PriceGuarantee ,
        heading:"Best Price Guarantee",
        content:"Book with Confidence as our Network get's us the best deal that out there! And just to make sure of it, if you find anything better, we will match any price out there, so you don't pay more for your cruise."

    }, {
        icon:EasyBooking ,
        heading:"Easy Booking and Cancellation",
        content:"Hold a booking for free till you make up your mind & free cancellation before 90 days to sailing* (differs from cruise line and sailing days)."

    }, {
        icon:ZeroService ,
        heading:"Zero Service Charge",
        content:"Multiple payment options with credit and debit cards, EMIs, wallets and bank transfers, and you get our expertise for No Service Charge."

    }, {
        icon:Cruise ,
        heading:"50+ Year Cruise Expertise",
        content:"With 50+ years of combined cruise industry expertise, we bring unmatched insights and trusted guidance to your travel plans. Trust the experience of cruise pioneers."

    }, {
        icon:Counsellor ,
        heading:"Dedicated Cruise Counsellor Assistance",
        content:"Say goodbye to call center frustrations—connect with the same expert every time and enjoy personalized support with a dedicated cruise counsellor who knows your booking inside out."

    }
]

export default Easecruisedata;